import {EventAnalysisStoreService} from "../event-analysis-store.service";
import {Injectable, OnDestroy} from "@angular/core";
import {ChartData} from "chart.js/auto";
import {TimelineDatasetProcessor} from "../../utils/chart/timeline/timeline-dataset-processor";
import {TimeRepository} from "../../repositories/core/time-repository/time-repository";
import {LinkedDtoRepository} from "../../../common/repositories/linked-dto-repository";
import {ColorMapService} from "../../../common/colors/color-map.service";
import {SalesRepository} from "../../repositories/core/sales-repository/sales-repository";
import {TimeInterval} from "../../../common/enums/time/time-interval";
import {SalesDto} from "../../models/sales/sales-dto";
import {BaseStore} from "../core/base-store";


@Injectable()
export class RevenueTimelineStore extends BaseStore implements OnDestroy {
  activeDataset!: ChartData
  intervalDuration: TimeInterval = TimeInterval.halfHour
  selectedOption: keyof SalesDto = "compositionTypeId"
  options: { key: keyof SalesDto, description: string }[] = [
    {key: "compositionTypeId", description: "Umsatz pro Kategorie"},
    {key: "locationId", description: "Umsatz pro Standort"},
    {key: "bookingType", description: "Umsatz pro Zahlungsmethode"}
  ]


  constructor(public eventAnalysisStoreService: EventAnalysisStoreService,
              private colorMapService: ColorMapService,
              private linkedDtoRepository: LinkedDtoRepository<any>,
              private timeRepository: TimeRepository,
              private salesRepository: SalesRepository) {
    super(eventAnalysisStoreService)

  }


  override update() {
    this.activeDataset = this.processDataset()
    this.updateNotifier.emit()
  }

  changeIntervalDuration(intervalDuration: TimeInterval) {
    this.intervalDuration = intervalDuration
    this.update()
  }

  /**
   * Use one of the this.options to set the option else it will throw an error
   * @param option
   */
  changeOption(option: keyof SalesDto) {
    this.selectedOption = option
    this.update()
  }

  containsOnlyPositiveValues(): boolean {
    return TimelineDatasetProcessor.verifyDatasetContainsOnlyPositiveValues(this.activeDataset)
  }

  getActiveDataset(): ChartData {
    return {...this.activeDataset}
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  private processDataset(): ChartData {
    return TimelineDatasetProcessor.processBarChartDataset(this.selectedOption, this.salesRepository.getSalesWrapper(), this.linkedDtoRepository, this.colorMapService, this.timeRepository.getTimeIntervalBO(), this.intervalDuration, this.eventAnalysisStoreService.getRevenueCalculation());
  }

}
